import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login?err=missing", { replace: true }); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post(`/auth/google?session_id=${encodeURIComponent(sid)}`);
        // clear the fragment
        window.history.replaceState({}, "", window.location.pathname);
        toast.success(`Welcome, ${data.user?.name || "traveller"}!`);
        await refresh?.();
        const role = data.user?.role;
        if (role === "client") navigate("/client-portal", { replace: true });
        else if (role === "driver") navigate("/driver-portal", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        const detail = formatErr(e.response?.data?.detail) || "Google sign-in failed";
        toast.error(detail);
        navigate(`/login?err=${encodeURIComponent(detail)}`, { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-amber-500/30 border-t-amber-500 rounded-full animate-spin mx-auto"></div>
        <div className="mt-3 text-sm text-muted-foreground">Verifying your Google session…</div>
      </div>
    </div>
  );
}
